export enum Module {
    Collections, // Incasso
    CollectionsForeign, // Incasso buitenland 
    LegalAid, // Rechtshulp
    TermsAndConditions // Algemene voorwaarden
}
